import React from "react";

import StateMachine from "../utils/StateMachine";
import ReCAPTCHA from "react-google-recaptcha";

import StepDetails from "./StepDetails_1st";
import StepVerification from "./StepVerification_2nd";
import StepSkills from "./StepSkills_3rd";
import StepInstagram from "./StepInstagram_4th";
import StepPhotos from "./StepPhotos_5th";
import StepCheckoutMembership from "./StepCheckoutMembership_6th";
import Success from ".//Success";
import { withRouter } from "react-router-dom";

class TalentApplication extends React.Component {
  render() {
      const { pathname } = this.props.location;
      const validPaths = [
          "/apply",
          "/apply/verification",
          "/apply/skills",
          "/apply/instagram",
          "/apply/photos",
          ...(process.env.REACT_APP_MEMBERSHIP_SELECTION_ENABLED === 'true' ? ["/apply/membership"] : []),
          "/apply/complete",
      ];

      if (!validPaths.includes(pathname)) {
          this.props.history.replace("/apply");
      }
    return (
      <StateMachine.State is="apply">
        <StateMachine.Consumer>
          {({ current }) => {
              const recaptchaRef = React.createRef();
              const needsRecaptcha = process.env.REACT_APP_RECAPTCHA_ENABLED === 'true' && (current.matches('apply.details') || current.matches('apply.verification'));
              return (
                <React.Fragment>
                  {needsRecaptcha && (
                    <ReCAPTCHA
                      ref={recaptchaRef}
                      size="invisible"
                      sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
                    />
                  )}
                  <StateMachine.State is="apply.details">
                      <StepDetails recaptchaRef={recaptchaRef}/>
                  </StateMachine.State>
                  <StateMachine.State is="apply.verification">
                      <StepVerification recaptchaRef={recaptchaRef}/>
                  </StateMachine.State>
                  <StateMachine.State is="apply.skills">
                    <StepSkills />
                  </StateMachine.State>
                    <StateMachine.State is="apply.instagram">
                        <StepInstagram />
                    </StateMachine.State>
                    <StateMachine.State is="apply.selectInstagramPhotos">
                        <StepPhotos />
                    </StateMachine.State>
                    <StateMachine.State is="apply.checkoutMembership">
                        <StepCheckoutMembership />
                    </StateMachine.State>
                  <StateMachine.State is="apply.complete">
                    <Success />
                  </StateMachine.State>
                </React.Fragment>
              );
          }}
        </StateMachine.Consumer>
      </StateMachine.State>
    );
  }
}

export default withRouter(TalentApplication);